module.exports = "mutation finishMatching($finishMatching:FinishMatchingInput!){finishMatching(finishMatching:$finishMatching)}"